import { render, staticRenderFns } from "./QuicklinksWidget.vue?vue&type=template&id=6be12fde&scoped=true&"
import script from "./QuicklinksWidget.vue?vue&type=script&lang=js&"
export * from "./QuicklinksWidget.vue?vue&type=script&lang=js&"
import style0 from "./QuicklinksWidget.vue?vue&type=style&index=0&id=6be12fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be12fde",
  null
  
)

export default component.exports